export const PRICING_SECTION_ID = 'pricing'

export function scrollToPricing(): void {
  const el = document.getElementById(PRICING_SECTION_ID)
  if (!el) return
  el.scrollIntoView({
    behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches
      ? 'auto'
      : 'smooth',
    block: 'start',
  })
}
